import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "earning",
        "startDate",
        "endDate",
        "metadataContainer"
    ]

    static values = {
        uploadEventName: String
    }

    connect() {
        this.uploadHandler = this.handleUpload.bind(this)
        this.element.addEventListener(this.uploadEventNameValue, this.uploadHandler)

        // Listen for clear events if we choose to implement them
        this.clearHandler = this.handleClear.bind(this)
        this.element.addEventListener("earnings-ocr:clear", this.clearHandler)
    }

    disconnect() {
        if (this.uploadHandler) {
            this.element.removeEventListener(this.uploadEventNameValue, this.uploadHandler)
        }
        if (this.clearHandler) {
            this.element.removeEventListener("earnings-ocr:clear", this.clearHandler)
        }
    }

    async handleUpload(event) {
        const { signed_id, path } = event.detail

        if (!path || !signed_id) return

        this.showLoadingState()

        try {
            const response = await fetch(path, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content
                },
                body: JSON.stringify({ blob_id: signed_id })
            })

            if (!response.ok) throw new Error("Network response was not ok")

            const data = await response.json()
            if (data.success) {
                this.fillFields(data.metadata)
            } else {
                console.error("OCR Error:", data.error)
            }
        } catch (error) {
            console.error("OCR Request failed:", error)
        } finally {
            this.hideLoadingState()
        }
    }

    handleClear() {
        this.clearFields()
    }

    fillFields(metadata) {
        if (!metadata) return

        this.metadataContainerTargets.forEach(mc => {
            mc.style.display = 'flex'
        })

        if (this.hasEarningTarget && metadata.earning) {
            this.earningTarget.disabled = false
            this.earningTarget.value = metadata.earning
            this.earningTarget.dispatchEvent(new Event('input', { bubbles: true }))
        }

        if (this.hasStartDateTarget && metadata.start_date) {
            this.startDateTarget.disabled = false
            this.startDateTarget.value = metadata.start_date
        }

        if (this.hasEndDateTarget && metadata.end_date) {
            this.endDateTarget.disabled = false
            this.endDateTarget.value = metadata.end_date
        }
    }

    clearFields() {
        this.metadataContainerTargets.forEach(mc => {
            mc.style.display = 'none'
        })

        if (this.hasEarningTarget) {
            this.earningTarget.value = ''
            this.earningTarget.disabled = true
            this.earningTarget.dispatchEvent(new Event('input', { bubbles: true }))
        }

        if (this.hasStartDateTarget) {
            this.startDateTarget.value = ''
            this.startDateTarget.disabled = true
        }

        if (this.hasEndDateTarget) {
            this.endDateTarget.value = ''
            this.endDateTarget.disabled = true
        }
    }

    showLoadingState() {
        // Implement if specific loading UI is needed for metadata fields
    }

    hideLoadingState() {
        // Implement if specific loading UI is needed for metadata fields
    }
}
